<template>
  <div class="runs-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Analyze Area' | trans }}</div>

    </div>

    <div>
      <p>
        {{ "Which area should the AI look at to better understand the context in which it should modify the image."| trans}}
      </p>

    <div class="runs-container">
      <div
          class="runs-btn"
          v-bind:class="{'active': activeStage.settings.inpainting_area === 'only_masked'}"
          @click="changeModeTo('only_masked')"
      >
        Only Masked Area
        <div
            v-bind:class="{'active': activeStage.settings.inpainting_area === 'only_masked'}"
            class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>

      </div>

      <div
          class="runs-btn"
          v-bind:class="{'active': activeStage.settings.inpainting_area === 'whole_picture'}"
          @click="changeModeTo('whole_picture')"
      >
        Whole Image
        <div
            v-bind:class="{'active': activeStage.settings.inpainting_area === 'whole_picture'}"
            class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>
      </div>
    </div>
    </div>

  </div>
</template>
<script>
//  [ 'fill', 'original', 'latent_noise', 'latent_nothing' ]
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import UploadBox from "../../Elements/UploadBox.vue";
import Prompt from "../../Elements/Prompt.vue";

export default {
  name: "InpaintingMode",
  props: {},
  components: {Prompt, UploadBox},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      item_open: false
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    changeModeTo(mode) {
      this.activeStage.settings.inpainting_area = mode;
    }
  },
  computed: {
    isActive() {
      return this.currentJob.state !== 'processing';
    },
    isDone() {
      return this.activeStage.settings.prompt !== '';
    }
  }
};
</script>
<style lang="scss" scoped>
.radio-indicator {
  background: white;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 21px;

  &.active {
    .radio-indicator-inner {
      background: #1266F1;
    }
  }

  padding: 3px;

  &.disabled {
    .radio-indicator-inner {
      background: #ccc;
    }
  }

  .radio-indicator-inner {
    border-radius: 50%;
    width: 15px;
    height: 15px;

  }
}

.thumb-item-container {
  cursor: pointer;
  font-weight: bold;
  display: flex;
  border: 3px dashed #ccc;
  border-radius: 9px;
  gap: 20px;
  align-items: start;
  padding: 20px 20px 20px 20px;

  &.active {
    border: 3px dashed #1266F1;
  }
}

.next-btn {
  cursor: pointer;

  color: white;
  border-radius: 4px;
  background: #1266F1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  gap: 20px;
  font-size: 17.5px;

  border: none;

  &.disabled {
    cursor: not-allowed;
  }
}


.gap-10px {
  gap: 10px;
}

.gap-20px {
  gap: 20px;
}

.gap-30px {
  gap: 30px;
}

.gap-40px {
  gap: 40px;
}

.runs-box {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.checkmark-box {
  color: white;
  background: #1266F1;
  border-radius: 50%;
  position: absolute;
  padding: 5px;
  width: 24px;
  height: 24px;
  right: -10px;
  top: -13px;
  justify-content: center;
  align-items: center;
  display: none;

  &.active {
    display: flex !important;
  }
}

.runs-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: stretch;
}

.runs-btn {
  cursor: pointer;
  border-radius: 9px;
  background: #383838;
  position: relative;
  display: flex;
  height: 48px;
  border: 3px solid transparent;
  gap: 10px;
  padding: 10px;
  align-items: center;

  &.active {
    border: 3px solid #1266F1;
  }

  &:hover {
    background: #323232;
  }
}
</style>
